const stylesReports = {
  color: {
    background: "linear-gradient(70deg, #7F8BFF, #55CEFF)",
    width: "100%",
  },
  stack: {
    marginTop: "6rem",
  },
  stackb: {
    alignItems: "flex-start",
  },
  stackc: {
    marginLeft: "2rem",
    padding: "1rem 2rem",
  },
  stackd: {
    margin: 5,
  },
  global: {
    position: "absolute",
    width: "100vw",
    height: "100vh",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor:"white"
  },
  title: {
    padding: "2rem 0rem",
    alignContent:"center"
  },
};

export default stylesReports;
